import styled from "@emotion/styled";

import { Container as ItemContainer } from "~/components/olympic-widgets/today-highlights/today-highlights-item/styles";
export const Container = styled.div`
  block-size: 100%;

  ${ItemContainer} {
    &:nth-child(even) {
      background-color: #f6f6f6;
    }

    &:last-child {
      border-block-end: 0;
    }
  }
`;
